var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error__message"},[_vm._v("Houve um erro de conexão.")]),_c('PrimaryButton',{on:{"click":function($event){return _vm.$emit('reconnect')}}},[_vm._v("Reconectar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }